@if (comentarioRespondido == true) {
  <button class="btn btn-sm"><i class="bi bi-check-circle"></i></button>
}

